export default __webpack_public_path__ + "static/seguridadicon-7fbb47cd27938fd7b543656b9f772d72.webp";